import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ImageGallery from '../../gallery/index';
import { AxiosAPI, getGroupID, getUserID } from '../../../../../../helpers/AxiosAPI';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import Validation from '../../../../../../components/Validation';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import {
    postAPI_EventsCreate,
    putAPI_EventsUpdate,
    gAPI_EventsById,
    gAPI_FormsBy_PropertyId,
    gAPI_Vouchers_List,
    gAPI_Internal_Property_By_Id,
    gAPI_Users_By_Id
} from '../../../../../../constants/APIs';

const quillModules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [
            { list: 'ordered' },
            { list: 'bullet' },
            { indent: '-1' },
            { indent: '+1' },
        ],
        ['link', 'image'],
        ['clean'],
    ],
};
const quillFormats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
];
export default function EventsForm({ id, visible, toggle, languageCode, propertyId, LoadData }) {
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [galleryVisible, setGalleryVisible] = useState(false);
    const [isAivaProperty, setIsAivaProperty] = useState(false);
    const [formsData, setFormsData] = useState([]);
    const [vouchers, setVouchers] = useState([]);
    const [eventsData, setEventsData] = useState({
        groupId: getGroupID(),
        propertyId: propertyId,
        title: [
            {
                statement: '',
                languageCode: languageCode,
            },
        ],
        description: [
            {
                statement: '',
                languageCode: languageCode,
            },
        ],
        eventDatesTime: '',
        imageLink: '',
        startDate: moment(),
        endDate: moment(),
        action: 'None',
        actionValue: {
            valueId: "",
            valueName: "",
            externalUrl: "",
            promoCode: "",
            instructions: [{
                statement: '',
                languageCode: languageCode,
            }],
            submitButtonText: [{
                statement: '',
                languageCode: languageCode,
            }]
        },
        displayOrder: 0,
        status: "Active",
        creator: 'Dashboard'
    });
    useEffect(() => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_FormsBy_PropertyId}?groupId=${getGroupID()}&propertyId=${propertyId}&lang=${languageCode}`,
        })
            .then((res) => {
                setFormsData(res.data);
            })
            .catch((err) => console.error(err));
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
        }).then((res) => {
            AxiosAPI({
                methhod: 'get',
                url: `${gAPI_Vouchers_List}?groupId=${getGroupID()}&propertyId=${propertyId}&languageCode=${languageCode}&search=&status=All&pageNumber=${1}&pageSize=${100}&email=${res.data.email}`,
            }).then((res) => {
                if (res.data.vouchers !== undefined && res.data.vouchers !== null && res.data.vouchers.length > 0) {
                    var voucherData = res.data.vouchers.filter(
                        (item) => item.status !== 'Draft'
                    );
                    setVouchers(voucherData);
                }
            });
        });
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
        })
            .then((res) => {
                setIsAivaProperty(res.data.isAiva);
            })
            .catch((err) => console.error(err));

        if (id !== undefined) {
            AxiosAPI({
                method: 'get',
                url: `${gAPI_EventsById}/${id}`,
            })
                .then((res) => {
                    setEventsData(res.data);
                });
        }
    }, [id]);

    const handleChangeStartDate = e => {
        setEventsData({
            ...eventsData,
            startDate: moment(e).format("YYYY-MM-DD 00:00:00"),
        });
    };

    const handleChangeEndDate = e => {
        setEventsData({
            ...eventsData,
            endDate: moment(e).format("YYYY-MM-DD 23:59:59"),
        });
    };

    const handleChange = e => {
        setEventsData({
            ...eventsData,
            [e.target.name]: e.target.value,
        });
    };
    const handleChangeTitle = (e) => {
        if (eventsData.title.length > 0) {
            const index = eventsData.title.findIndex(
                (m) => m.languageCode === languageCode
            );
            if (index === -1) {
                const newStatement = {
                    statement: e.target.value,
                    languageCode: languageCode,
                };
                setEventsData({
                    ...eventsData,
                    title: [...eventsData.title, newStatement],
                });
            } else {
                let newArr = [...eventsData.title];
                newArr[index].statement = e.target.value;
                setEventsData({
                    ...eventsData,
                    title: newArr,
                });
            }
        } else {
            const newStatement = {
                statement: e.target.value,
                languageCode: languageCode,
            };
            setEventsData({
                ...eventsData,
                title: [...eventsData.title, newStatement],
            });
        }
    }
    const getLocalStatement = (statements) => {
        if (statements !== undefined && statements !== null && statements.length > 0) {
            const index = statements.findIndex((m) => m.languageCode === languageCode);
            if (index === -1) {
                const englishIndex = statements.findIndex(
                    (m) => m.languageCode === 'en'
                );
                if (englishIndex !== -1) {
                    return statements[englishIndex].statement;
                }
            } else {
                return statements[index].statement;
            }
        } else {
            return '';
        }
    };
    const handleChangedescription = (source, e) => {
        if (source === 'user') {
            if (eventsData.description.length > 0) {
                const index = eventsData.description.findIndex(
                    (m) => m.languageCode === languageCode
                );
                if (index === -1) {
                    const newStatement = {
                        statement: e,
                        languageCode: languageCode,
                    };
                    setEventsData({
                        ...eventsData,
                        description: [...eventsData.description, newStatement],
                    });
                } else {
                    let newArr = [...eventsData.description];
                    newArr[index].statement = e;
                    setEventsData({
                        ...eventsData,
                        description: newArr,
                    });
                }
            } else {
                const newStatement = {
                    statement: e,
                    languageCode: languageCode,
                };
                setEventsData({
                    ...eventsData,
                    description: [...eventsData.description, newStatement],
                });
            }
        }
    };
    const handleChangeActionValueArr = (e) => {
        var actionvalue = { ...eventsData };
        if (actionvalue.actionValue !== null) {
            var value = { ...actionvalue.actionValue };
            if (e.target.name === "submitButtonText") {
                if (value.submitButtonText !== null && value.submitButtonText.length > 0) {
                    const index = value.submitButtonText.findIndex((m) => m.languageCode === languageCode);
                    if (index === -1) {
                        const newStatement = {
                            statement: e.target.value,
                            languageCode: languageCode,
                        };
                        value.submitButtonText = [...value.submitButtonText, newStatement];
                    } else {
                        let newArr = [...value.submitButtonText];
                        newArr[index].statement = e.target.value;
                        value.submitButtonText = newArr;
                    }
                }
                else {
                    const newStatement = {
                        statement: e.target.value,
                        languageCode: languageCode,
                    };
                    value.submitButtonText = [newStatement];
                }
            }
            else if (e.target.name === "instructions") {
                if (value.instructions !== null && value.instructions.length > 0) {
                    const index = value.instructions.findIndex((m) => m.languageCode === languageCode);
                    if (index === -1) {
                        const newStatement = {
                            statement: e.target.value,
                            languageCode: languageCode,
                        };
                        value.instructions = [...value.instructions, newStatement];
                    } else {
                        let newArr = [...value.instructions];
                        newArr[index].statement = e.target.value;
                        value.instructions = newArr;
                    }
                }
                else {
                    const newStatement = {
                        statement: e.target.value,
                        languageCode: languageCode,
                    };
                    value.instructions = [newStatement];
                }
            }
            setEventsData({
                ...eventsData,
                actionValue: value,
            });
        }
    }
    const togglegallery = () => {
        setGalleryVisible(!galleryVisible);
    };
    const selectedImage = (image) => {
        setEventsData({
            ...eventsData,
            imageLink: image.src,
        });
    };
    const handleRemoveImage = () => {
        setEventsData({
            ...eventsData,
            imageLink: '',
        });
    };
    const handleSignUpAiva = () => {
        window.open('https://app.getaiva.com/user/vouchersignup');
    };
    const handleLearnMoreAiva = () => {
        window.open('https://getaiva.com/');
    };

    const handleChangeActionValue = (e) => {
        var actionvalue = { ...eventsData };
        if (actionvalue.actionValue !== null) {
            var value = { ...actionvalue.actionValue };
            value[e.target.name] = e.target.value;
            setEventsData({
                ...eventsData,
                actionValue: value
            });
        }
    };

    const handleChangeVoucher = (e) => {
        var voucher = vouchers
            .filter((item) => item.id === e.target.value)
            .map((i) => i.name);
        let voucherName = '';
        if (voucher.length > 0) {
            voucherName = voucher[0];
        }
        var actionvalue = { ...eventsData }
        if (actionvalue.actionValue !== null) {
            var value = { ...actionvalue.actionValue };
            value.valueId = e.target.value;
            value.valueName = voucherName;
            setEventsData({
                ...eventsData,
                actionValue: value
            });
        }
    };

    const handleChangeForm = (e) => {
        let formId = e.target.value;
        let formName = '';
        var form = formsData.filter((item) => item.id === e.target.value);
        if (form.length > 0) {
            formName = form[0].name;
        }
        var actionvalue = { ...eventsData }
        if (actionvalue.actionValue !== null) {
            var value = { ...actionvalue.actionValue };
            value.valueId = formId;
            value.valueName = formName;
            setEventsData({
                ...eventsData,
                actionValue: value
            });
        }
    };

    const handleSubmit = () => {
        if (id !== undefined) {

            const formmatedData = { ...eventsData, Updater: 'admin' };

            AxiosAPI({
                method: 'put',
                url: `${putAPI_EventsUpdate}/${id}`,
                data: formmatedData,
            })
                .then(res => {
                    if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                        && res.data.Messages !== null && res.data.Messages.length > 0) {
                        setMsg(res.data.Messages);
                        setOpen(true);
                    }
                    else {
                        setTimeout(() => {
                            toggle();
                            LoadData();
                        }, 1000)
                    }
                })
                .catch(err => {
                    console.log('err', err);
                });
        }
        else {
            const formmatedData = { ...eventsData };
            AxiosAPI({
                method: 'post',
                url: `${postAPI_EventsCreate}`,
                data: formmatedData,
            })
                .then(res => {
                    if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                        && res.data.Messages !== null && res.data.Messages.length > 0) {
                        setMsg(res.data.Messages);
                        setOpen(true);
                    }
                    else {
                        setTimeout(() => {
                            toggle();
                            LoadData();
                        }, 1000);
                    }
                }

                )
                .catch(err => {
                    console.log('err', err);
                });
        }
    };
    const ImageGalleryButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={galleryVisible} toggle={togglegallery} style={{ maxWidth: '1000px' }}>
                                <ModalHeader toggle={togglegallery}>
                                    Select Image or Upload New Image
                                </ModalHeader>
                                <ModalBody>
                                    <ImageGallery propertyId={propertyId} selectedImage={selectedImage} togglegallery={togglegallery}
                                        hideUserUploads={false} searchText={""} />
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };
    return (
        <Modal isOpen={visible} toggle={() => toggle()}
            wrapClassName="modal-right"
            backdrop="static">
            <ModalHeader toggle={() => toggle()}>Events Calendar</ModalHeader>
            <ModalBody>
                <Row>
                    <Colxx sm={12}>
                        <Label className="mt-3">Title</Label>
                        <Input
                            type="text"
                            onChange={handleChangeTitle}
                            value={getLocalStatement(eventsData.title)}
                            name="title"
                            maxLength={50}
                            placeholder={"Title"}
                        />
                    </Colxx>
                    <Colxx sm={12}>
                        <Label className="mt-3">Description</Label>
                        <ReactQuill
                            theme="snow"
                            value={getLocalStatement(eventsData.description)}
                            onChange={(content, delta, source) =>
                                handleChangedescription(source, content)
                            }
                            modules={quillModules}
                            formats={quillFormats}
                            name="description"
                        />
                    </Colxx>
                    <Colxx sm={12}>
                        <Label className="mt-3">Events Dates/Time</Label>
                        <Input
                            type="textarea"
                            onChange={handleChange}
                            value={eventsData.eventDatesTime}
                            name="eventDatesTime"
                            maxLength={30}
                            placeholder="Events Dates/Time"
                        />
                    </Colxx>
                    <Colxx sm={6}>
                        <Label className="mt-3">Display Start Date</Label>
                        <DatePicker
                            selected={eventsData.startDate ? moment(eventsData.startDate).toDate() : null}
                            onChange={(date) => handleChangeStartDate(date)}
                            placeholderText="Start Date"
                            dateFormat="dd/MM/yyyy"   // react-datepicker format
                        />
                        {/* <Input
                            required
                            type="date"
                            name="startDate"
                            value={moment(eventsData.startDate).format('YYYY-MM-DD')}
                            onChange={handleChange}
                        /> */}
                    </Colxx>
                    <Colxx sm={6}>
                        <Label className="mt-3">Display End Date</Label>
                        <DatePicker
                            selected={eventsData.endDate ? moment(eventsData.endDate).toDate() : null}
                            onChange={(date) => handleChangeEndDate(date)}
                            placeholderText="End Date"
                            dateFormat="dd/MM/yyyy"   // react-datepicker format
                            popperPlacement="right-start"
                        />
                        {/* <Input
                            required
                            type="date"
                            name="endDate"
                            value={moment(eventsData.endDate).format('YYYY-MM-DD')}
                            onChange={handleChange}
                        /> */}
                    </Colxx>
                    <Colxx sm={6}>
                        <Label className="mt-3"><IntlMessages id='dashboards.displayOrder' /> </Label>
                        <Input
                            type="number"
                            name="displayOrder"
                            value={eventsData.displayOrder}
                            onChange={(e) => setEventsData({ ...eventsData, displayOrder: e.target.value })}
                        ></Input>
                    </Colxx>
                    <Colxx sm={6}>
                        <Label className="mt-3">Status</Label>
                        <Input
                            type="select"
                            name="status"
                            value={eventsData.status}
                            onChange={handleChange}
                        >
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                            <option value="Archieve">Archive</option>
                        </Input>
                    </Colxx>
                    <Colxx sm={12}>
                        <Label className="mt-3">Order/Buy Method</Label>
                        <Input
                            type="select"
                            name="action"
                            value={eventsData.action}
                            onChange={handleChange}
                        >
                            <option value="0">Select</option>
                            <option value="ExternalURL">External URL  (Inside Compendium)</option>
                            <option value="ExternalURLNewWindow">External URL (New Window)</option>
                            <option value="PromoCode">Promo Code</option>
                            <option value="aiva">aiva</option>
                            <option value="CreateTicket">Create Ticket (Pre Check-in)</option>
                            <option value="CreateTicketInStay">Create Ticket (In Stay)</option>
                            <option value="TakePayment">Take Payment</option>
                            <option value="SubmitForm">Submit Form</option>
                        </Input>
                        {eventsData.action === 'PromoCode' && (
                            <div className="row">
                                <div className="col-12">
                                    <Label className="mt-3">Promo Code</Label>
                                    <Input
                                        type="text"
                                        onChange={handleChangeActionValue}
                                        value={eventsData.actionValue.promoCode}
                                        name="promoCode"
                                        placeholder="Promo Code"
                                    />
                                </div>
                                <div className="col-12">
                                    <Label className="mt-3">External Link (Url)</Label>
                                    <Input
                                        type="text"
                                        onChange={handleChangeActionValue}
                                        value={eventsData.actionValue.externalUrl}
                                        name="externalUrl"
                                        placeholder="External Link (Url)"
                                    />
                                </div>
                                <div className="col-12">
                                    <Label className="mt-3">Instructions</Label>
                                    <Input
                                        type="textarea"
                                        onChange={handleChangeActionValueArr}
                                        value={getLocalStatement(eventsData.actionValue.instructions)}
                                        name="instructions"
                                        placeholder="Instructions"
                                    />
                                </div>
                            </div>
                        )}
                        {eventsData.action === 'ExternalURL' ||
                            eventsData.action === 'ExternalURLNewWindow' ? (
                            <div className="row">
                                <div className="col-12">
                                    <Label className="mt-3">External Link (Url)</Label>
                                    <Input
                                        type="text"
                                        onChange={handleChangeActionValue}
                                        value={eventsData.actionValue.externalUrl}
                                        name="externalUrl"
                                        placeholder="External Link (Url)"
                                    />
                                </div>
                                <div className="col-12">
                                    <Label className="mt-3">Instructions</Label>
                                    <Input
                                        type="textarea"
                                        onChange={handleChangeActionValueArr}
                                        value={getLocalStatement(eventsData.actionValue.instructions)}
                                        name="instructions"
                                        placeholder="Instructions"
                                    />
                                </div>
                                <div className='col-12'>
                                    <Label className="mt-3">Action Button Text</Label>
                                    <Input
                                        type="text"
                                        value={getLocalStatement(eventsData.actionValue.submitButtonText)}
                                        onChange={handleChangeActionValueArr}
                                        name="submitButtonText"
                                        placeholder="Submit Form Text"
                                    />
                                </div>
                            </div>
                        ) : null}
                        {eventsData.action === 'SubmitForm' ?
                            <Fragment>
                                <Label className="mt-3">Select Forms</Label>
                                <Input
                                    type="select"
                                    name="forms"
                                    value={eventsData.actionValue.valueId}
                                    onChange={handleChangeForm}
                                >
                                    <option value="">Select</option>
                                    {formsData && formsData.map((item, i) =>
                                        <option value={item.id} key={i}>{item.name}</option>
                                    )}
                                </Input>
                                {eventsData.actionValue.valueId !== "" &&
                                    <Fragment>
                                        <Label className="mt-3">Action Button Text</Label>
                                        <Input
                                            type="text"
                                            value={getLocalStatement(eventsData.actionValue.submitButtonText)}
                                            onChange={handleChangeActionValueArr}
                                            name="submitButtonText"
                                            placeholder="Submit Form Text"
                                        />
                                    </Fragment>
                                }
                            </Fragment>
                            : null}
                        {isAivaProperty === true && eventsData.action === 'aiva' ? (
                            <Fragment>
                                <Label className="mt-3">Select Voucher(s)</Label>
                                <Input
                                    type="select"
                                    name="vouchers"
                                    value={eventsData.actionValue.valueId}
                                    onChange={handleChangeVoucher}
                                >
                                    <option value="">Select</option>
                                    {vouchers.length > 0 &&
                                        vouchers.map(
                                            (item) =>
                                                item.name !== '' && (
                                                    <option value={item.id}>{item.name}</option>
                                                )
                                        )}
                                </Input>
                            </Fragment>
                        ) : (
                            eventsData.action === 'aiva' && (
                                <div className="text-center p-2 mt-2">
                                    <p style={{ fontSize: '15px' }}>
                                        <b>aiva</b> is an automated, direct sell voucher system
                                        allowing you to offer fully branded vouchers on your
                                        website.{' '}
                                    </p>
                                    <p className="mt-3" style={{ fontSize: '15px' }}>
                                        Currently, you do not have an account for <b>aiva</b>. It's
                                        quick, inexpensive, simple and smart. Ten minutes is all it
                                        takes to sign-up and upload your first voucher.
                                    </p>
                                    <div
                                        className="d-flex"
                                        style={{
                                            flexDirection: 'column',
                                            alignContent: 'center',
                                            flexWrap: 'wrap',
                                        }}
                                    >
                                        <Button
                                            style={{ marginTop: '20px' }}
                                            color="primary"
                                            onClick={() => handleLearnMoreAiva()}
                                            size="xs"
                                        >
                                            Learn More <FontAwesomeIcon icon={faArrowRight} />
                                        </Button>
                                        <Button
                                            style={{ marginTop: '20px' }}
                                            color="primary"
                                            onClick={() => handleSignUpAiva()}
                                            size="xs"
                                        >
                                            Sign Up <FontAwesomeIcon icon={faArrowRight} />
                                        </Button>
                                    </div>
                                </div>
                            )
                        )}
                        {eventsData.actionValue.valueId !== null &&
                            eventsData.actionValue.valueId !== '' &&
                            eventsData.actionValue.valueName !== null &&
                            eventsData.actionValue.valueName !== '' &&
                            eventsData.action === 'aiva' && (
                                <div className="text-left p-2 mt-2">
                                    <span>
                                        <a
                                            href={
                                                `${process.env.REACT_APP_VOUCHERAIVA_URL}/vhp?id=` + eventsData.actionValue.valueId
                                            }
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            style={{ textDecoration: 'underline', fontWeight: '600' }}
                                        >
                                            Click here
                                        </a>{' '}
                                        to view the voucher
                                    </span>
                                    <br />
                                </div>
                            )}
                    </Colxx>
                    <Colxx sm={12}>
                        <Label className="mt-3">Image</Label>
                        <div className="text-center">
                            {eventsData.imageLink != null && eventsData.imageLink != "" ? (
                                <div className="thumbnail">
                                    <img className="list-thumbnail responsive border-0" src={eventsData.imageLink} />
                                    <a href="#/" className="remove" data-dz-remove
                                        onClick={() => handleRemoveImage()}
                                    >
                                        {" "}
                                        <i className="glyph-icon simple-icon-trash" />{" "}
                                    </a>
                                </div>
                            ) : ''}

                            <Button color="secondary" className="mt-1" onClick={togglegallery}>
                                <IntlMessages id='dashboards.browsegallery' />
                            </Button>
                        </div>
                    </Colxx>
                </Row>
            </ModalBody>
            <ModalFooter>
                {id !== undefined ?
                    <Button
                        color="primary"
                        onClick={() => handleSubmit()}
                    >
                        Update
                    </Button> :
                    <Button
                        color="primary"
                        onClick={() => handleSubmit()}
                    >
                        Add
                    </Button>}

                <Button
                    color="secondary"
                    onClick={() => toggle()}
                >
                    Close
                </Button>
            </ModalFooter>
            {ImageGalleryButton()}
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Modal>
    )
}